export default class GlassDesignerAPIService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  // Library Items
  getLibraryItems(options = {}, filter = {}) {
    var params = {
      filter: filter || {},
      include: options.include
    }

    var queryString = '/ordereditor/libraryitems?' + $.param(params)
    return this.httpClient.get(queryString)
  }

  getLibraryItem(id)            { return this.httpClient.get(`/ordereditor/libraryitems/${id}`) }
  createLibraryItem(data)       { return this.httpClient.post(`/ordereditor/libraryitems`, data) }
  updateLibraryItem(id, data)   { return this.httpClient.put(`/ordereditor/libraryitems/${id}`, data) }
  deleteLibraryItem(id)         { return this.httpClient.delete(`/ordereditor/libraryitems/${id}`) }
  

  // Configuration - Cutouts
  getOrderEditorCutoutList()                          { return this.httpClient.get(`/ordereditor/cutouts`) }

  // Configuration - Edgeworks
  getOrderEditorEdgeworkList(options = {}, filter = {}) {
    var params = {
      filter: filter || {},
      include: options.include
    }

    var queryString = '/ordereditor/edgeworks?' + $.param(params)
    return this.httpClient.get(queryString)
  }
  getOrderEditorDefaultEdgeworkList()                 { return this.httpClient.get(`/ordereditor/defaultedgeworks`) }
  getStockOrderEditorDefaultEdgeworkList(stockId)     { return this.httpClient.get(`/ordereditor/stock/${stockId}/defaultedgeworks`) }

  // Configuration - Shape Price Types
  getOrderEditorShapePriceTypeList()                  { return this.httpClient.get(`/ordereditor/shapepricetypes`) }

  // Configuration - Guidelines
  getOrderEditorGuidelines()                          { return this.httpClient.get(`/ordereditor/guidelines`) }


  // Configuration - Settings
  getConfigSettings()                                 { return this.httpClient.get(`/ordereditor/settings`) }
}
